import { ExternalLink, Monitor } from "lucide-react";
import { PARTNER_LINK } from "@/lib/constants";

const AddRedSection = () => (
  <section id="addred" className="py-10 md:py-16">
    <div className="container">
      <div className="mx-auto max-w-3xl rounded-2xl border border-border/60 bg-card p-5 sm:p-6">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary">
            <Monitor className="h-4 w-4" aria-hidden="true" />
          </div>
          <div>
            <h2 className="font-display text-lg font-bold text-foreground sm:text-xl md:text-2xl">
              heilys AddRed – Rotlicht-Schreibtischlampe für den Alltag
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">
              Die AddRed Schreibtischlampe ist besonders spannend für Menschen, die viel am Bildschirm
              arbeiten. Sie verbindet Arbeitsplatzbeleuchtung mit einem lichtbiologisch interessanten
              Ansatz und passt dadurch sehr gut zu Biohacking, Fokus, Abendroutine und moderner
              Bildschirmarbeit.
            </p>
            <div className="mt-5">
              <a
                href={PARTNER_LINK}
                target="_blank"
                rel="sponsored noopener noreferrer"
                onClick={() => window.lh?.trackAffiliate({ source: "addred" })}
                className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/20 transition-all hover:brightness-110"
              >
                AddRed ansehen
                <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AddRedSection;
